export { default } from './CollectionRail';
